// Investor demo sign-in (owner, 2026-10-30): a demo login needs no password,
// and a direct link signs straight in:
//   /auth/login?demo=fleet     -> the Northwind fleet manager
//   /auth/login?demo=personal  -> the personal account (one car)
//   /auth/login?email=demo-...@aperiomobility.com
// The server only lets this through for accounts registered as demo
// accounts (server modules/demo/demo-login.ts); they are read-only.

export const DEMO_LOGIN_EMAILS: Record<string, string> = {
  fleet: 'demo-fleet@aperiomobility.com',
  personal: 'demo-driver@aperiomobility.com',
};

const DEMO_LOGIN = /^demo-[a-z0-9._+-]*@aperiomobility\.com$/i;

export function isDemoLoginEmail(email: unknown): boolean {
  return typeof email === 'string' && DEMO_LOGIN.test(email.trim());
}

/** The demo login a link asks for (`?demo=` or a demo `?email=`), if any. */
export function demoLoginFromParams(params: URLSearchParams): string | null {
  const demo = DEMO_LOGIN_EMAILS[(params.get('demo') || '').toLowerCase()];
  if (demo) return demo;
  const email = params.get('email')?.trim() || '';
  return isDemoLoginEmail(email) ? email.toLowerCase() : null;
}
